import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';
import { useLearnedRecipes } from '../hooks/useLearnedRecipes';
import { LearnedRecipesTable } from '../components/LearnedRecipesTable';

export function LearnedRecipesPage() {
  const [userId, setUserId] = useState('');
  const [searchUserId, setSearchUserId] = useState('');

  const { learnedRecipes, loading, error } = useLearnedRecipes({
    userId: searchUserId || undefined,
    admin: true,
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchUserId(userId);
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Learned Recipes</h1>

      <form onSubmit={handleSearch} className="flex gap-2 max-w-md">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="User ID..."
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            className="pl-9"
            aria-label="Search by user ID"
          />
        </div>
        <Button type="submit" variant="secondary">
          Search
        </Button>
      </form>

      {error && <p className="text-sm text-destructive">{error}</p>}

      {!searchUserId ? (
        <p className="text-center text-muted-foreground py-12">
          Enter a user ID to view their learned recipes.
        </p>
      ) : (
        <LearnedRecipesTable learnedRecipes={learnedRecipes} loading={loading} />
      )}
    </div>
  );
}
